/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

const constants = require('./constants');

/**
 * @module enervee_utils.ads
 * AppNexusService is responsible for initializing appNexus tag slots and changing keywords
 * based on category and product so that appNexus sends the correct ad to show
 */
AppNexusService.$inject = [
    '$rootScope',
    '$window',
    'UtilService',
    '$timeout',
    '$log',
];
function AppNexusService(
    $rootScope,
    $window,
    UtilService,
    $timeout,
    $log
) {
    var appNexusId = UtilService.getSiteSetting('appnexus_member_id'),
        appNexusUser = UtilService.getSiteSetting('appnexus_user_settings'),
        marketPlaceTitle = UtilService.getSiteSetting('title'),
        INDEX = '-HP-',
        RESULTS = '-CAT-',
        PRODUCT = '-PROD-',
        apnInitialized = false,
        apnPages = {},
        tagParameters = [],
        defaultKeywords = {
            'marketplace': marketPlaceTitle,
            'category': '',
            'productID': '',
            'rebate': '',
            'brand': '',
            'score': '',
            'offers_count': '',
            'price': '',
            'rating': '',
            'reviews': '',
            'popularity': ''
        };

    // Set keywords for AppNexus on page when category changed
    $rootScope.$on('categorySet', handleCategorySet);

    var _pub = {
        isEnabled: UtilService.isFeatureEnabled('appnexus_tags'),
        isMobile: UtilService.isMobile,
        initAppNexus: initAppNexus,
        INDEX: INDEX,
        RESULTS: RESULTS,
        PRODUCT: PRODUCT,
        createTag: createTag
    };

    return _pub;

    /**
     * Initialize AppNexus for the page specified
     * @param {Object} keywords - An object of keywords that will override the defaults for AppNexus
     * @param {string} appNexusTagsCategory - The name of the page to initialize AppNexus for
     */
    function initAppNexus(keywords, appNexusTagsCategory) {
        if (_pub.isEnabled === true) {
            // Set keywords for page
            setPageOptions(keywords);
            if (!apnPages.hasOwnProperty(appNexusTagsCategory)) {
                // Page hasn't been initialized, create the tags
                createTagParameters(appNexusTagsCategory);
            } else {
                var pageAppNexusTags = apnPages[appNexusTagsCategory];

                // Refresh ad to show when category/product changed
                pageAppNexusTags.forEach(refreshTagParameters);
                $rootScope.$on('contentReady', function () {
                    handleRefreshAds(pageAppNexusTags);
                });
            }
        }
    }

    /**
     * Define and load tags from AppNexus to prepare for the page
     */
    function createTagParameters(page) {
        apnPages[page] = [];
        // Push commands to loading queue, to allow for async loading
        $window.apntag.anq.push(function () {
            // Get AppNexus ad slots
            var deviceType = _pub.isMobile() ? 'mobile' : 'desktop',
                appNexusSettings = $.extend(true, {}, UtilService.getSiteSetting('appnexus_settings', {})),
                appNexusAdSlots = appNexusSettings[deviceType] || {};
            // Define ad tags
            for (var slot in appNexusAdSlots) {
                if (slot.indexOf(page) === -1) {
                    continue;
                }
                var params = appNexusAdSlots[slot];
                params.targetId = slot.toString();
                tagParameters[params.targetId] = params;
                apnPages[page].push(slot);
            }
        });
    }

    /**
     * Delete extra parameters blocking Ad from reloading
     */
    function refreshTagParameters(tag) {
        var params = tagParameters[tag];
        delete params.sizes;
        params.displayed = false;
        params.showTagCalled = false;
     }

    /**
     * Define and load tags from AppNexus to prepare for the page
     * @param {Object} keywords - An object of keywords that will override the defaults for AppNexus
     * @param {string} page - The name of the page to initialize AppNexus for
     */
    function createTag(targetId) {
        if (!(targetId in tagParameters)) {
            $log.warn("Appnexus tag " + targetId + " does not have parameters settings.");
            return;
        }

        $window.apntag.anq.push(function () {

            var params = tagParameters[targetId];

            // appnexus code add sizes on defineTag. need to remove them if there
            $window.apntag.defineTag(params);
            UtilService.debounce(
                "loadTags",
                function () {
                    $window.apntag.loadTags();
                },
                500
            );
        });
    }

    /**
     * Handle the refreshing ads for categories.
     * @param {Array} pageAppNexusTags - The list of tags to refresh ads on
     */
    function handleRefreshAds(pageAppNexusTags) {
       $window.apntag.anq.push(function () {
            $timeout(function () {
                $window.apntag.refresh(pageAppNexusTags);
            });
        });
    }

    /**
     * Handle the changing of categories. This currently only updates the keywords/options for AppNexus
     * @param {event}  e - The event object passed from angular
     * @param {Object} category - The category object passed with the $emit call
     */
    function handleCategorySet(e, category) {
        // Category has been changed, lets update the page options
        if (_pub.isEnabled === true &&
            apnInitialized === true &&
            $window.apntag.setPageOpts !== undefined) {
            var keywords = {
                category: category.name,
                rebate: category.is_rebatable
            };
            setPageOptions(keywords);
        }
    }

    /**
     * Set the AppNexus page options with the passed object of keywords
     * @param {Object} keywords - An object of keywords that will override the defaults for AppNexus
     */
    function setPageOptions(keywords) {
        // Fill up all keywords for the page
        keywords = angular.extend({}, defaultKeywords, keywords);
        $window.apntag.anq.push(function () {
            $window.apntag.setPageOpts({
                member: appNexusId,
                keywords: keywords,
                user: appNexusUser
            });
        });
    }
}

module.exports = AppNexusService;
